import { action } from 'typesafe-actions';
import { IRegionConfigsState, RegionConfigDashboardTypes } from './types';

export const getAllRegionConfigRecords = (university: string, pathway?: string) => {
  return action(RegionConfigDashboardTypes.GET_ALL_REGION_CONFIGS, {
    university,
    pathway,
  });
};
export const getAllRegionConfigRecordsSuccess = (regionConfig: IRegionConfigsState) =>
  action(RegionConfigDashboardTypes.GET_ALL_REGION_CONFIGS_SUCCESS, regionConfig);
export const getAllRegionConfigRecordsFailure = (error: string) =>
  action(RegionConfigDashboardTypes.GET_ALL_REGION_CONFIGS_FAILURE, error);
export const getAllFilterRegionConfigRecords = (university: string, pathway?: string) => {
  return action(RegionConfigDashboardTypes.GET_ALL_FILTER_REGION_CONFIGS, {
    university,
    pathway,
  });
};
export const getAllFilterRegionConfigRecordsSuccess = (regionConfig: IRegionConfigsState) =>
  action(RegionConfigDashboardTypes.GET_ALL_FILTER_REGION_CONFIGS_SUCCESS, regionConfig);
export const getAllFilterRegionConfigRecordsFailure = (error: string) =>
  action(RegionConfigDashboardTypes.GET_ALL_FILTER_REGION_CONFIGS_FAILURE, error);
